import { SET_PARENTS } from "../actions/type";

const initialState = [];

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PARENTS:
      return action.payload;

    default:
      return state;
  }
};